<template>
  <div class="deliverySheet">
    <div ref="bigorder-print-single-body" class="print-body print-font print-single-body">
      <div class="title print-font">发货清单</div>
      <div class="ds-desc print-font">
        <div class="top">
          <span>主单号：</span>
          <span>{{main_number}}</span>
          <span class="send-date">发货日期：</span>
          <span>{{out_ware_day}}</span>
          <span class="delivery">快递单号:</span>
          <span>{{courier_number}}</span>
          <span class="delivery">编号:</span>
          <span>{{serial_number}}</span>
        </div>
        <div class="btm">
          <span>收货方:</span>
          <span>{{receivingPhone}}</span>
        </div>
      </div>
      <div class="ds-table print-font">
        <el-table
          :data="deliveryData"
          size="small"
          style="width: 100%"
        >
          <el-table-column
            label="序号"
            type="index"
            width="50"
          >
          </el-table-column>
          <el-table-column
            prop="order_number"
            label="子订单号"
            width="120"
          >
          </el-table-column>
          <!-- <el-table-column
            prop="express"
            label="物流承运商"
            width="95"
          >
          </el-table-column> -->
          <el-table-column
            prop="ruigu_code"
            label="商品编号"
            width="95"
          >
          </el-table-column>
          <el-table-column
            prop="name"
            label="商品名称"
            min-width="250"
          >
          </el-table-column>
          <el-table-column
            prop="unit"
            label="单位"
            width="45"
          >
          </el-table-column>
          <el-table-column
            prop="send_amount"
            label="数量"
            width="45"
          >
          </el-table-column>
        </el-table>
      </div>
      <div class="order-total print-font">
        <span>合计</span>
        <span class="num">{{total}}</span>
      </div>
    </div>
    <div class="print-group" ref="bigorder-print-group">
      <div class="print-delivery">
        <div class="print-body print-font" style="page-break-after: always;" v-show="exportData.length !== 0" v-for="item in exportData" :key="item.main_number">
          <div class="title print-font">发货清单</div>
          <div class="ds-desc print-font">
            <div class="top">
              <span>主单号：</span>
              <span>{{item.main_number}}</span>
              <span class="send-date">发货日期：</span>
              <span>{{item.out_ware_day}}</span>
              <!--<span class="delivery">快递名称:</span>
              <span>{{courier_name}}</span>-->
              <span class="delivery">快递单号:</span>
              <span>{{item.courier_number}}</span>
              <span class="delivery">编号:</span>
              <span>{{item.serial_number}}</span>
            </div>
            <div class="btm">
              <!-- <span>发货方：</span>
              <span>{{user_name}}</span> -->
              <span>收货方:</span>
              <span>{{item.receivingPhone}}</span>
            </div>
          </div>
          <div class="ds-table print-font">
            <el-table
              :data="item.list"
              :fit="true"
              style="width:100%"
            >
              <el-table-column
                label="序号"
                type="index"
                width="50"
              >
              </el-table-column>
              <el-table-column
                prop="order_number"
                label="子订单号"
                width="120"
              >
              </el-table-column>
              <!-- <el-table-column
                prop="express"
                label="物流承运商"
                width="95"
              >
              </el-table-column> -->
              <el-table-column
                prop="ruigu_code"
                label="商品编号"
                width="95"
              >
              </el-table-column>
              <el-table-column
                prop="name"
                label="商品名称"
                min-width="250"
              >
              </el-table-column>
              <el-table-column
                prop="unit"
                label="单位"
                width="45"
              >
              </el-table-column>
              <el-table-column
                prop="send_amount"
                label="数量"
                width="45"
              >
              </el-table-column>
            </el-table>
          </div>
          <div class="order-total print-font">
            <span>合计</span>
            <span class="num">{{item.total}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="print-btn">
      <el-button type="primary" size="small" @click="myPrint">打印</el-button>
    </div>
  </div>
</template>

<script>
import { getshippingListLogistics, bigorderBatchExportGoodsDetail } from '@/models/orderModel'
import print from '@/utils/mixins/print'
export default {
  name: 'deliverySheet',
  props: ['id', 'ids'],
  mixins: [print],
  data () {
    return {
      isZhifaOrFactory: true,
      deliveryData: [],
      orderNo: '',
      main_number: '',
      user_name: '',
      out_ware_day: '',
      courier_number: '',
      receivingPhone: '',
      total: '',
      courier_name: '',
      serial_number: '',
      express: '',
      exportData: [],
      failedData: []
    }
  },
  methods: {
    myPrint () {
      // this.$nextTick(function () {
      //   let subOutputRankPrint = document.querySelector('.print-single-body')
      //   let newContent = subOutputRankPrint.innerHTML
      //   let oldContent = document.body.innerHTML
      //   document.body.innerHTML = newContent
      //   window.print()
      //   window.location.reload()
      //   document.body.innerHTML = oldContent
      //   return false
      // })
      setTimeout(() => {
        this.browser_print('bigorder-print-single-body')
      }, 1000)
    },
    async getshippingListLogistics () {
      let params = {
        id: this.$route.query.id
      }
      this.loadOrderTable = true
      let data = await getshippingListLogistics(params)
      this.deliveryData = data.list
      this.main_number = data.main_number
      this.user_name = data.user_name
      this.out_ware_day = data.out_ware_day
      this.courier_number = data.courier_number
      this.receivingPhone = data.receivingPhone
      this.serial_number = data.serial_number
      // this.courier_name = data.courier_name || ''
      this.total = data.total
      // return Promise.resolve(1)
    },
    async print () {
      // let params = {
      //   id: this.id
      // }
      // this.loadOrderTable = true
      // let data = await getshippingListLogistics(params)
      // this.deliveryData = data.list
      // this.main_number = data.main_number
      // this.user_name = data.user_name
      // this.out_ware_day = data.out_ware_day
      // this.courier_number = data.courier_number
      // this.receivingPhone = data.receivingPhone
      // this.serial_number = data.serial_number
      // this.total = data.total
      // this.express = data.express
      let ids = []
      let failedData = []
      this.ids.forEach(item => {
        ids.push(item.id)
      })
      let params = {
        ids: ids.join(',')
      }
      this.loadOrderTable = true
      let res = await bigorderBatchExportGoodsDetail(params)
      if (res.code === 200) {
        this.exportData = res.data.succeed
        failedData = res.data.failed
      }
      if (failedData.length > 0) {
        failedData.forEach(item => {
          item.main_number = this.ids.find(order => {
            return order.id === item.id
          }).main_number
        })
        this.failedData = failedData
        let html = ''
        failedData.forEach(item => {
          html += '<p style="padding:5px;">主订单号：' + item.main_number + ',' + item.msg + '</p>'
        })
        this.$message({
          showClose: true,
          type: 'error',
          iconClass: '11',
          dangerouslyUseHTMLString: true,
          message: html,
          duration: 0
        })
      } else {
        this.$nextTick(function () {
          // let subOutputRankPrint = document.querySelector('.print-group')
          // let newContent = subOutputRankPrint.innerHTML
          // let oldContent = document.body.innerHTML
          // document.body.innerHTML = newContent
          // window.print()
          // window.location.reload()
          // document.body.innerHTML = oldContent
          // return false
          setTimeout(() => {
            this.browser_print('bigorder-print-group')
          }, 1000)
        })
      }
    }
  },
  created () {
    if (!this.id) {
      this.getshippingListLogistics()
    }
  }
}
</script>
<style lang="scss">
.deliverySheet {
  .print-body {
    width:700px;
    padding: 10px;
    border: 1px solid #000;
    .title {
      text-align: center;
      font-size: 18px;
      font-weight: 700;
      padding-bottom: 10px;
    }
    .ds-desc {
      font-size: 14px;
      font-weight: 700;
      .send-date {
        display: inline-block;
        padding-left: 20px;
      }
      .delivery {
        padding-left: 20px;
      }
      .btm {
        padding: 5px 0;
        .receiver {
          padding-left: 107px;
        }
      }
    }
    .order-total {
      font-size: 14px;
      font-weight: 700;
      line-height: 35px;
      .num {
        float: right;
        padding-right: 55px;
      }
    }
  }
  .print-btn {
    text-align: center;
    margin-top: 20px;
  }
}
//  .el-picker-panel__footer,
//   .el-table {
//     font-size: 14px;
//   }
  // .ds-table .el-table .cell,
  // .ds-table .el-table th div.cell,
  // .ds-table .el-table tr.el-table__row td div {
  //     padding: 5px !important;

  // }
//   .ds-table .el-table .cell {
//     -webkit-box-sizing: border-box;
//     box-sizing: border-box;
//     white-space: normal;
//     word-break: break-all;
//     line-height: 28px;
//   }
//   .ds-table .el-table th > .cell {
//     height: 28px;
//   }
//   .ds-table .el-table thead {
//     color: fff;
//   }
//   .ds-table .el-table th > .cell {
//     height: 36px;
//     line-height: 33px;
//   }
</style>



// WEBPACK FOOTER //
// src/pages/bigorder/delivery-sheet.vue